<template>
    <Scroll :on-reach-bottom="handleReachBottom" height="700" :distance-to-edge=[0,10]>
    <div class="kucun">
        <div class="topBar">
            <div class="daohang">
                <span @click="tiaozhuan" style="cursor: pointer; font-size:20px;color:#2d8cf0;font-family:'微软雅黑' "><Icon type="ios-home"></Icon>{{language.shouye}}</span>>
                <span style="cursor: pointer; font-size:20px;font-family:'微软雅黑'">{{language.jiagongdingdanshenqingchakan}}</span>
            </div>
            <div class="iptc">
                <div class="iptlis">
                    <Icon type="ios-search" class='ico'></Icon>
                    <input  class="iptli" :placeholder='language.chaxunqingdianjiwo'  type="primary" @click="modal1 = true">
                    <div class="numEve">
                    <div class="numlitter">{{language.gong}}{{numnum}}{{language.tiao}}</div></div>
                </div>
            </div>
        </div>
        <modal class="serchlist"  v-model="modal1"
         width="86%" :styles="{top: '60px',left:'100px'}">
            <div class="pz">
                <Input :placeholder=language.qingxuanze type="text" v-model="numpinzhong" clearable style="width: 200px"></Input>
                <span class='pinzhongs'>{{language.shenqingpicihao}}</span>
            </div>
            <div class="kuan">
            <DatePicker type="date" v-model="numpaihao" @on-change="getDateTime" placeholder="Select date" style="width: 200px" class="dataipt"></DatePicker>
            <span class="sqrq">{{language.shenqingriqi}}</span>
            </div>

            <div class="hou">
                <span class='hous'>{{language.shenqingzhuangtai}}</span>
                <Select :placeholder=language.qingxuanze name="" id="" v-model="numhou" clearable style="width: 200px">
                    <Option v-for="item in cityList" :value="item.value" :key="item.value">{{item.label}}</Option>
                </Select>
            </div>
            <div slot="footer" style="background-color:rgb(249,249,249);">
            <div class="chaxun" @click='chaxun()'>{{language.chaxun}}</div>
            <div class="chongzhi" @click='chongzhis()'>{{language.chongzhi}}</div>
        </div>
        </modal>
        
    <Table border :columns="columns1" :data="data1" class="border farherTable"></Table>
        <div class="add_more_data">
            <Col class="demo-spin-col" span="24" v-show="jiazai">
                    <Spin fix>
                        <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
                        <div>Loading</div>
                    </Spin>
            </Col>
            <p class="add_more_data_btn" v-show="moredata">
              {{language.jiazaiwanbi}}
            </p>
        </div>
        <!-- <button @click="totWeight()">111</button> -->
    <div class="bootBanner">
            <p class="liang">
                       <span class="add_more_all_weight">{{language.heji}}： <div class="add_more_all_weight_span">{{resl}}</div>kg</span>
        <span class="add_more_add_more_down_load_btn" @click="downLoadData">

                <Icon type="archive" class="down"></Icon>
        {{language.shujuxiazai}}
        </span>


            </p>
    </div>
        </div>
        </Scroll>
</template>
<style scoped>
    .kucun{
    margin-bottom: 90px;
    }
    .bootBanner{
    overflow:hidden;
    min-width:100%;
    margin-top:50px;
    position: fixed;
    bottom:-5px;
    margin-top:30px;
    z-index: 10;
    overflow:hidden;
    margin-top:300px;
    }
    .bootBanner span span{
    float: right;
    width:120px;
    height:70px;
    line-height: 70px;
    border: 1px solid #ccc;
    text-align:center;
    background-color:#1d92be;
    cursor:pointer;
    font-size: 18px;
    margin-right: 5px;
    display: block;
    }
    .bootBanner .ivu-icon{
    margin-right:5px;
    color: #ffffff;
    font-size: 20px;
    }
    .bootBanner .liang{
    background-color:#e5ebf2;
    display: block;
    height: 100px;
    margin-right:150px;
    }
    .serchlist input{
    width:200px;
    height: 30px;
    /*margin-top:30px;*/
    border:1px solid #dddddd;
    text-align: center;
    border-radius: 3px;
    }
    .serchlist .pz span{
    position: absolute;
    left: 10px;
    top:-10px;
    background-color: white;
    }
    .serchlist .chanpinyuanliao span{
    width:80px;
    position: absolute;
    left: 10px;
    top:-10px;
    background-color: white;
    }
    .serchlist .pz,.ph,.hou,.kuan,.zhuangtai,.leixing,.qishi,.zhongzhi,.chanpinyuanliao{
    position: relative;
    /*float: left;*/
    margin-left: 150px;
    margin-top: 20px;
    display: inline-block;
    /*border-radius:5px;*/
    }
    .serchlist .ph span{
    width:80px;
    position: absolute;
    left: 10px;
    top:-15px;
    }
    .serchlist .hou span{
    width:60px;
    text-align: center;
    position: absolute;
    left: 10px;
    top:-10px;
    background-color:white;
    z-index: 2;
    }
    .serchlist .leixing span{
    width:50px;
    position: absolute;
    left: 10px;
    top:-15px;
    }


    .serchlist .zhuangtai span{
    position: absolute;
    left: 10px;
    top:-15px;
    }
    .serchlist .kuan span{
    width:50px;
    position: absolute;
    left: 10px;
    top:-8px;
    background-color: white;
    }


    .chaxun,.chongzhi{
    width:120px;
    height: 40px;
    background-color:#1d92be;
    border-radius: 10px;
    text-align: center;
    line-height: 40px;
    color: #f5f5f5;
    /*margin-top: 40px;*/
    display: inline-block;
    margin-right: 350px;
    }
    .serchlist select{
    width:200px;
    height: 30px;
    border-radius: 5px;
    border:1px solid #dddddd;
    }

    .topBar{
    position: relative;
    }
    .numlitter{
    margin-right: 20px;
    }

    .iptlis{
    position: relative;
    }
    .iptlis .ico{
    position: absolute;
    right: 278px;
    top:23px;
    z-index: 11111; 
    }
    .numEve{
    position: absolute;
    right: 61px;
    top:15px;
    line-height: 30px;
    background-color:#ffffff;
    height: 30px;
    width: 250px;
    text-align: right;
    color: #0066ff;
    }
    .kucun .daohang{
    margin-left: 20px;
    margin-top:10px;
    }
    .daohang{
    position: absolute;
    top:10px;
    left: 10px;
    z-index: 10;
    }
    .iptli{
    width:140px;
    border:none;
    height: 24px; 
    position: absolute;
    right: 170px;
    top:18px;
    cursor: pointer;
    background-color: #eaeaea;
    padding-left:30px;
    text-align:left;
    border-radius: 3px;
    z-index: 10;
    text-align:center;
    }
    .iptc{
    height: 65px;
    position: relative;
    background:url(../assets/header.gif)repeat-x 0 0px;
    background-color: #cdd9e8;
    border-color: #8ba0bc;
    }
    .classtit{
    height: 30px;
    }
    .classtit div{
    color:#2d8cf0;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-bottom:2px solid #2d8cf0;
    width:150px;
    }
    .classtit:hover{
    color:blue;
    }

    .add_more_down_load{
    width:100%;
    height:80px;
    position:relative;
    /*right: 0;*/
    /*bottom:200px;*/
    /*font-size:;*/
    background-color:#e5ebf2;
    }
    .add_more_all_weight{
    width:250px;
    height:65px;
    line-height:100px;
    position: absolute;
    top: 0px;
    left:5px;
    text-align:center;
    background-color:#e5ebf2;
    }
    .add_more_all_weight_span{
    color:red;
    display: inline-block;
    }
    .add_more_add_more_down_load_btn{
    width:120px;
    height:100px;
    line-height:100px;
    float: right;
    margin-right: 60px;
    position: relative;
    text-align:center;
    cursor:pointer;
    background-color:#1d92be;
    color:#fff;
    }
    .down{
    width:30px;
    height:30px;
    position:absolute;
    top:10px;
    right:38px;
    font-size: 30px;
    }
    .add_more_data{
    width:100%;
    height:60px;
    position: relative;
    }
    .add_more_data_btn{
    /*width:120px;*/
    height:40px;
    line-height:40px;
    position: absolute;
    top: 5px;
    left:50%;
    transform: translateX(-50%);
    text-align:center;
    cursor:pointer;
    }
    .add_more_data_btn:hover{
    color:#2d8cf0;
    }
    .jia{
    text-align: center;
    cursor: pointer;
    }
    .box{
    height: 83px;
    background-color:rgba(204,204,204,1);
    border: 1px solid black;
    }
    .ivu-table-wrapper{
    width: 100%;
    border:none;
    }

    .ivu-tabs{
    width:100%;
    }

    .ivu-table td{
    border: 1px solid #e9eaec;
    }
</style>
<script>
    import {mapGetters,mapActions} from 'vuex';
    import axios from 'axios';
    import expandRow from './table-expand.vue';
    import config from 'config/apiConfig'
    import language from 'api/language.js'
	export default {
        data () {
            return {
                language:{},
                valpeo:"",
                totalPageCount:'',
                 cityList: [
                    {
                        value: '20',
                        label: language.daishenpi,
                    },
                    {
                        value: '60',
                        label: language.shengchengdingdan,
                    },
                    {
                        value: '00',
                        label: language.chexiaochenggong,
                    },
                    {
                        value: '02',
                        label: language.bufenshenpi,
                    },
                    {
                        value: '01',
                        label: language.xitongshenpibutongguo,
                    },
                    {
                        value: '30',
                        label: language.yewuyuanshenpitongguo,
                    },
                    {
                        value: '03',
                        label: language.yewuyuanshenpibutongguo,
                    },
                ],
                columns1: [
                    {
                        title:'',
                        type: 'expand',
                        align: 'center',
                        width: 50,
                        render: (h, params) => {
                            return h('div', {},[
                                h(expandRow, {
                                    on:{

                                        'on-change':(event) => {
                                      this.changeData(params,event)
                                    }
                                    },
                                    props: {
                                        rows3: params.row,
                                    },
                                    style:{
                                        margin:'0px -30px',
                                    }
                                })
                            ])
                        }
                    },
                    {
                        title: language.shenqingpicihao,
                        align:'center',
                        key: 'applyCode',
                    },
                    {
                        title: language.jiagongzhongliang,
                        align:'center',
                        key: 'weight'
                    },
                    {
                        title: language.shenqingshijian,
                        align:'center',
                        key: 'applyTime'
                    },
                    {
                        title: language.shenqingzhuangtai,
                        align:'center',
                        key: 'statusName',
                    },
                    {
                        title: language.beizhu,
                        align:'center',
                        key: 'remarks'
                    }
                ],
                modal1:false,
                // resl:0,
                numbewdata:[],
                resl:0,
                data1: [],
                jiazai:false,
                loadnum:[],
                addMoreData:true,

                numpinzhong:'',
                numpaihao:'',
                numhou:'',
                cpyl:'',
                numchang:'',
                numkuan:'',
                numcangku:'',
                numkunbaohao:'',
                nummujuanhao:'',
                numnum:'',
                orderNum:'',
                packNumK:'',
                prodCode:'',
                raval:false ,
                dataVal:"",
                indexVal:"",
                moRenDate:true,
                moredata:false,
            }
        },
        components: { expandRow },
        methods:{
            ...mapActions({
                showNameTabs: 'showNameTabs'
            }),
             handleReachBottom(){
                return new Promise(ig => {
                    setTimeout(() => {
                        let that=this;
                        let paramsData = {"offset": that.data1.length,"limit":'10',"applyCode":that.numpinzhong,"applyTime":that.numpaihao,"status":that.numhou,"stockType":that.cpyl}
                        if(that.data1.length%10 != 0){ that.moredata=true; return;}
                        if(that.totalPageCount%10 == 0 && that.data1.length == that.totalPageCount){ that.moredata=true; return;}
                        that.jiazai=true
                        
                        axios.post(config.queryJGApplyHeadList,paramsData).then(function(response){
                        ig();
                           
                        if(response.data.resultCode == 1){
                            that.jiazai=false
                            that.data1 = that.data1.concat(response.data.resultData);
                            that.resl=response.data.page.totalWeight
                            that.$Message.info(language.jiazaiwanbi)

                            // console.log(response)
                        }else{
                            that.$Message.info(response.data.fsuffix)

                        }
                    })
                    return
                    }, 500);
                });
            },
            changeData(index,value){
                let that = this
                that.dataVal=index
            if(value != null  &&  value.length>0){
                    let activeIndex = 0;
                    for(var i=0; i<value.length;i++){
                        if(value[i].status!="00"){
                            activeIndex = 1;
                            that.currentdata()
                            that.totWeight()
                        }
                    }
                    if(activeIndex == 0){
                        that.currentdata()
                        that.totWeight()
                    }

                }

            },
            totWeight(index){
                let that = this;
                let params={}
                axios.post(config.queryJGApplyHeadList,params).then(function(response){
                    if(response.data.resultCode=="1"){
                        that.resl=response.data.page.totalWeight
                    }
                })
            },
            currentdata(){
                let that = this;
                let params={
                    "applyCode":that.dataVal.row.applyCode
                }
                axios.post(config.queryJGApplyHeadList,params).then(function(response){
                    if(response.data.resultCode=="1"){
                        that.dataVal.row.weight=response.data.resultData[0].weight
                        if(response.data.resultData[0].weight==null || response.data.resultData[0].weight=='0'){
                        that.dataVal.row.statusName=response.data.resultData[0].statusName
                        }
                    }
                })
            },
            getDateTime(value){
                this.numpaihao = value;
            },
             chongzhis(){
                let that = this;
                that.numpinzhong="";
                that.numpaihao="";
                that.cpyl="";
                that.numhou="";
                that.numchang="";
                that.numkuan="";
                that.numcangku="";
                that.numkunbaohao="";
                that.mujuanhaos="";
            },
            tiaozhuan(){
                this.$router.push({name: 'firstpage',params:{ id:'1'}});
            },

            chaxun(){
                let that = this;
                let params={};
                params.applyCode = that.numpinzhong;
                params.applyTime = that.numpaihao;
                params.stockType = that.cpyl;
                params.status = that.numhou;
                that.$Message.success({
                    content: language.qingshaodeng,
                    duration: 2,
                    closable: true
                })
                axios.post(config.queryJGApplyHeadList,params).then(function(response){
                    if(response.data.resultCode==1){
                        that.numnum=response.data.page.totalPageCount
                        that.data1=response.data.resultData;
                        that.modal1=false
                        that.resl=response.data.page.totalWeight

                    }
                })
            },
            add(response){
                let that=this
                let weight=""
                for (var i = 0 ; i < that.index.processQuerySubBeanLists.length; i++) {
                    if(that.processQuerySubBeanLists.value==null){
                        this.weight.value='0'
                    }
                }
            },
            downLoadData(){
                this.$Message.success({
                    content: language.qingshaodeng,
                    duration: 2,
                    closable: true
                })
                let that = this;
            let paramsData = {
                "applyCode" : that.numpinzhong,
                "applyTime" : that.numpaihao,
                "stockType" : that.cpyl,
                "status" : that.numhou,
            }
            axios({method: 'post',url: config.applyQueryExpt,data: paramsData,responseType: 'blob'}).then(function(response){
                const content = response.data
                const blob = new Blob([content])
                const fileName = 'download.xls'
                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)

                // that.$Message.success({
                //     content: '下载完成',
                //     duration: 2,
                //     closable: true
                // })
                } else { // IE10+下载
                    navigator.msSaveBlob(blob, fileName)
                }

            })
            .catch(function (error) {
                console.log(error)
            });
            },
            showPanel(){
                this.panlshow=true;
            },
            ig(indexs){
                let that=this;
                let paramsData = {"offset": that.data1.length,"limit":'10',"applyCode":that.numpinzhong,"applyTime":that.numpaihao,"status":that.numhou,"stockType":that.cpyl}
                if(that.data1.length%10 != 0){ that.moredata=false; return;}
                if(that.totalPageCount%10 == 0 && that.data1.length == that.totalPageCount){ that.moredata=false; return;}
                axios.post(config.queryJGApplyHeadList,paramsData).then(function(response){
                   
                    if(response.data.resultCode == 1){

                        that.data1 = that.data1.concat(response.data.resultData);
                        that.resl=response.data.page.totalWeight
                        that.$Message.info(language.jiazaiwanbi)

                        // console.log(response)
                    }else{
                        that.$Message.info(response.data.fsuffix)

                    }
                })
                return
            },
            // 加载结束
            iclist(){
                let that = this;
                that.language = language;
                axios.post(config.queryJGApplyHeadList,{}).then(function(response){
                    that.data1=response.data.resultData;
                    // that.totalPageCount= response.data.totalPageCount;
                    if(response.data.resultCode=="1"){
                        that.resl=response.data.page.totalWeight
                    }
                    
                })
            },

        },


        mounted(){
            // this.rng()
            this.iclist()
            // this.currentdata()
           // this.ig()
        }
    }

</script>



// WEBPACK FOOTER //
// addpost.vue?ecb03bba